import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";

export function useEphemeralEnvironmentsEnabled() {
    return useOctopusFeatureToggle("ephemeral-environments", false);
}
